import { format } from 'date-fns'
import extractDomain from '~/tools/extractDomain'

export const addToCalendar = ({title, description, permalink, scheduleStartDate, scheduleEndDate}) => {
	const url = `${extractDomain(window.location.href)}${permalink}`
	const scheduleDate = `${format(new Date(scheduleStartDate), 'YYYYMMDDTHHmmss')}/${format(new Date(scheduleEndDate), 'YYYYMMDDTHHmmss')}`
	window.open(
		`https://calendar.google.com/calendar/r/eventedit?text=${encodeURIComponent(title)}&dates=${scheduleDate}&details=${encodeURIComponent(description)}`,
		'Add To Calendar',
		'status=no,toolbar=no,location=no,directories=no,menubar=no'
	)
}